import React, { useMemo } from 'react';
import { Bookings } from 'screens/Authenticated/Bookings';
import { buildNewBookingUrl } from 'screens/Authenticated/Bookings/bookingCalendarActions';
import DrawerMenu from 'components/DrawerMenu';
import strings from 'common/Translation/Translate';
import { Box, Button } from '@mui/material';
import PostAddIcon from '@mui/icons-material/PostAdd';
import { useNavigate } from 'react-router-dom';

type DiaryModalProps = {
  open: boolean;
  onClose: () => void;
  urlParam?: any;
};

const BookingDiary: React.FC<DiaryModalProps> = ({ open, onClose, urlParam }) => {
  const navigate = useNavigate();
  const diaryModal = useMemo(() => {
    return (
      <Bookings
        hideNewBookingButton={urlParam?.companyBranch}
        modal={true}
        newBookingParams={urlParam?.companyBranch ? urlParam : undefined}
      />
    );
  }, [urlParam]);
  return (
    <DrawerMenu
      width="80%"
      open={open}
      title={
        <Box display="flex" alignItems="center">
          {strings.booking_diary}
          {urlParam?.companyBranch && (
            <Button
              onClick={() => navigate(buildNewBookingUrl(new Date(), urlParam))}
              variant="contained"
              size="small"
              startIcon={<PostAddIcon />}
              sx={{ ml: 2, textTransform: 'none', whiteSpace: 'nowrap' }}>
              {strings.new_booking_title}
            </Button>
          )}
        </Box>
      }
      handleClose={onClose}
      closeButton={true}>
      <Box width="100%" my={2}>
        {diaryModal}
      </Box>
    </DrawerMenu>
  );
};

export default BookingDiary;
